import { useLanguage } from '@orientaction/hooks';
import { getFromLS } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getCompassTestYearHistories } from '../../../../services/user.service';
import { HistoryDropdown } from '../../shared';
import locale from '../locale.json';

const HistoryButton = () => {
  const [years, setYears] = useState<number[]>([]);

  const { year, userId }: any = useParams();
  const { language } = useLanguage();
  const history = useHistory();

  const token = getFromLS('userToken');
  const userConnected = JSON.parse(getFromLS('userInfos') || '{}');
  const userConnectedId = userConnected.id;

  useEffect(() => {
    if (token && userConnectedId) {
      const idUser = userId || userConnectedId;
      getCompassTestYearHistories(token, idUser).then(response => {
        setYears(response.data.compassTestYearHistories);
      });
    }
  }, [token, userConnectedId, userId]);

  const handleYearSelect = (selectedYear: string | number) => {
    const currentYear = Number(selectedYear);

    if (userId) {
      history.push(`/admin/${userId}/boussole/${currentYear}`, { force: true });
      return;
    }

    history.push(
      `${language === 'GB' ? `/en/my-compass/${currentYear}` : `/ma-boussole/${currentYear}`}`,
    );
  };

  return (
    <HistoryDropdown
      items={years.map(historyYear => ({
        id: historyYear,
        label: String(historyYear),
      }))}
      activeId={year ? +year : undefined}
      onSelect={handleYearSelect}
      label={locale.history}
    />
  );
};

export default HistoryButton;
